"use strict";
/**
 * This is the main typescript file
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const proxySpy_1 = __importDefault(require("@common/tsutils/proxySpy"));
//
// Configure moment
//
const moment_1 = __importDefault(require("moment"));
require("moment/locale/es");
require("moment/locale/fr");
require("vue-select/dist/vue-select.css");
// Import the old js version
require("./app_old");
/**
 * Get a meta tag
 */
function getMeta(name, def) {
    var _a, _b;
    const query = `meta[name="${name}"]`;
    const val = (_b = (_a = document.querySelector(query)) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) !== null && _b !== void 0 ? _b : null;
    if (def && !val) {
        return val;
    }
    return val;
}
const locale = getMeta('portal-locale', 'en');
moment_1.default.locale(locale);
// TODO: Remove this when moment is loaded locally in all places.
if (getMeta('portal-environment') === 'local') {
    console.warn("Using moment globally :'(");
}
if (true) {
    window.moment = (0, proxySpy_1.default)(moment_1.default, 'Using moment globally');
}
else {
    window.moment = moment_1.default;
}
